import axios from "axios";
import {
  EVENT_NAME_FAIL,
  EVENT_NAME_REQUEST,
  EVENT_NAME_SUCCESS,
  UNIVERSITY_ATTENDED_COUNT_FAILED,
  UNIVERSITY_ATTENDED_COUNT_REQ,
  UNIVERSITY_ATTENDED_COUNT_SUCCESS,
  UNIVERSITY_COUNT_FAILED,
  UNIVERSITY_COUNT_REQ,
  UNIVERSITY_COUNT_SUCCESS,
} from "../constants/eventConstants";
import api from "../core/api";
let Api = process.env.REACT_APP_SEARCH_API_URL2;
export const getEventDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: EVENT_NAME_REQUEST,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.get(`/event/${id}`, config);

      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: EVENT_NAME_FAIL,
          payload: dt,
        });
      } else {
        dispatch({
          type: EVENT_NAME_SUCCESS,
          payload: dt[0].EventName,
        });
      }
    } else {
      dispatch({
        type: EVENT_NAME_FAIL,
        payload: "User Not Logged In!",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: EVENT_NAME_FAIL,
      payload: message,
    });
  }
};

export const getEventCrmDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: EVENT_NAME_REQUEST,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await axios.get(`${Api}/event/${id}`, config);

      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: EVENT_NAME_FAIL,
          payload: dt,
        });
      } else {
        dispatch({
          type: EVENT_NAME_SUCCESS,
          payload: dt[0].EventName,
        });
      }
    } else {
      dispatch({
        type: EVENT_NAME_FAIL,
        payload: "User Not Logged In!",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: EVENT_NAME_FAIL,
      payload: message,
    });
  }
};

export const UniversityCount = (eventId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UNIVERSITY_COUNT_REQ,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.get(
        `/universityCount/guest/${eventId}`,
        config
      );
      // console.log(data);
      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: UNIVERSITY_COUNT_FAILED,
          payload: dt,
        });
      } else {
        dispatch({
          type: UNIVERSITY_COUNT_SUCCESS,
          payload: dt[0],
        });
      }
    } else {
      dispatch({
        type: UNIVERSITY_COUNT_FAILED,
        payload: "User Not Logged In!",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: EVENT_NAME_FAIL,
      payload: message,
    });
  }
};

export const AttendedStuentCount =
  (eventId, guestCrm) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UNIVERSITY_ATTENDED_COUNT_REQ,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = guestCrm
          ? await axios.get(
              `${Api}/guest/InsertComment/accessrecord/${eventId}`,
              config
            )
          : await api.get(
              `/guest/InsertComment/accessrecord/${eventId}`,
              config
            );
        console.log(data);
        const dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: UNIVERSITY_ATTENDED_COUNT_FAILED,
            payload: dt,
          });
        } else {
          dispatch({
            type: UNIVERSITY_ATTENDED_COUNT_SUCCESS,
            payload: data.Result,
          });
        }
      } else {
        dispatch({
          type: UNIVERSITY_ATTENDED_COUNT_FAILED,
          payload: "Not attended !",
        });
      }
    } catch (error) {
      console.log(error);
      const message =
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message;
      dispatch({
        type: EVENT_NAME_FAIL,
        payload: message,
      });
    }
  };

export const Get_Guest_Activity = (eventId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UNIVERSITY_ATTENDED_COUNT_REQ,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await axios.get(
        `${Api}/guestactivity/guest/getUniversity/${eventId}`,
        config
      );
      console.log(data);
      const dt = data.Result;
      if (typeof dt == "string") {
        dispatch({
          type: UNIVERSITY_ATTENDED_COUNT_FAILED,
          payload: dt,
        });
      } else {
        dispatch({
          type: UNIVERSITY_ATTENDED_COUNT_SUCCESS,
          payload: data.Result,
        });
      }
    } else {
      dispatch({
        type: UNIVERSITY_ATTENDED_COUNT_FAILED,
        payload: "No Record !",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.Result
        ? error.response.data.Result
        : error.message;
    dispatch({
      type: UNIVERSITY_ATTENDED_COUNT_FAILED,
      payload: message,
    });
  }
};
